import { Link as UIKitLink } from '@medely/ui-kit';
import type { ProRoutes } from '@mp/routes';

export const Link = UIKitLink<ProRoutes>;
